// extracted by mini-css-extract-plugin
module.exports = {"cellRemark":"weight_cellRemark__JVRC1"};